import React from 'react';
import Logo2Image from '../assets/images/logo.png';
import LogoImage from '../assets/images/logo.png';

const Logo = ({ height = 128, width = 100 }) => <img src={Logo2Image} height={height} width={width} />
const Logo2 = () => <img src={LogoImage} height="43" width="100%" />

export { Logo, Logo2 };
